import { SvgIconOwnProps, Tooltip } from '@mui/material';
import StarsIcon from '@mui/icons-material/Stars';
import { useTranslation } from 'react-i18next';

export default function SubscriberContentIcon(
  iconProps: Readonly<SvgIconOwnProps>,
) {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('article.isSubscriberContent')}>
      <StarsIcon {...iconProps} color='primary' />
    </Tooltip>
  );
}
